<template>

    <div>
        <h4 class="mb-2">Workers waiting adoption</h4>

        <vx-card>
            <vs-table id="table2" ref="table" @selected="openWorkerAdoption" v-model="selected" pagination :max-items="5" search :data="tableData">

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableData.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableData.length }} of {{ tableData.length }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="cpu">CPU</vs-th>
                    <vs-th sort-key="ip">IP</vs-th>
                    <vs-th sort-key="port">Port</vs-th>
                </template>

                <template slot-scope="{data}">
                    <tbody>
                        <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                            <vs-td :data="data[index].cpu">
                                {{ data[index].cpu }}
                            </vs-td>

                            <vs-td :data="data[index].ip">
                                {{ data[index].ip }}
                            </vs-td>

                            <vs-td :data="data[index].port">
                                {{ data[index].port }}
                            </vs-td>

                        </vs-tr>
                    </tbody>
                </template>

            </vs-table>
        </vx-card>

        <vs-popup title="Adopt worker" :active.sync="adoptWorkerPrompt">
            <div id="adoptWorkerDiv" class="vs-con-loading__container" >
                <vx-card class="mb-6 p-0" card-background="warning" content-color="#fff" v-if="selected.license_disabled">
                    <div class="vx-row">
                        <div class="vx-col w-1/12">
                            <feather-icon style="color:#fff" icon="AlertTriangleIcon" color="#fff" class="mt-2"/>
                        </div>
                        <div class="vx-col w-11/12">
                            <p>Cannot adopt worker! <br>License limit reached</p>
                        </div>
                    </div>

                </vx-card>
                <h4>Docker version</h4>
                <p>{{selected.docker_version}}</p>
                <h4 class="mt-6">CPU</h4>
                <p>{{selected.cpu}}</p>
                <h4 class="mt-6">RAM</h4>
                <p>{{selected.ram}}</p>
                <h4 class="mt-6">Swap</h4>
                <p>{{selected.swap}}</p>
                <h4 class="mt-6">IP</h4>
                <p>{{selected.ip}}</p>
                <h4 class="mt-6">Port</h4>
                <p>{{selected.port}}</p>
                <h4 class="mt-6">GPUs</h4>
                <div :key="data.uuid" v-for="(data) in selected.gpu">
                    <h6 class="mt-3">{{data.name}}</h6>
                    <div class="ml-6 mb-6">
                        <p><b>Total memory: </b>{{(data.total_memory/1000).toFixed(2)}}GB</p>
                        <p><b>Driver version: </b>{{data.driver_version}}</p>
                        <p><b>VBios version: </b>{{data.v_bios_version}}</p>
                        <p><b>Serial: </b>{{data.serial_number}}</p>
                        <p><b>UUID: </b>{{data.uuid}}</p>

                    </div>
                </div>
                <vs-divider/>
                <vs-button :disabled="selected.license_disabled" color="success" icon-pack="feather" icon="icon-arrow-right" class="mt-6; mr-1" @click="goToAdoption">Go to adoption</vs-button>
            </div>
        </vs-popup>

    </div>
</template>
<script>
    export default {

        data() {
            return {

                selected: {},
                itemsPerPage: 20,
                isMounted: false,

                workers: [],
                adoptWorkerPrompt: false,

                addObject: {},

                updateDataTimer: '',
                initialLoadFinished: false

            }
        },
        methods: {
            openWorkerAdoption() {
                this.adoptWorkerPrompt = true
            },
            loadData() {
                if (!this.initialLoadFinished) {
                    this.$vs.loading({
                        container: '#table2',
                        type: 'corners',
                        scale: 0.7
                    })
                }

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker/?type=waiting_adoption')
                loadPromise.then(function(response) {
                    thisIns.workers = response.data
                })

                loadPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                loadPromise.finally(function() {
                    thisIns.initialLoadFinished = true
                    thisIns.$vs.loading.close('#table2 > .con-vs-loading')
                })
            },
            goToAdoption() {
                const key = this.selected.adoption_key
                this.adoptWorkerPrompt = false
                this.$nextTick(() => {
                    this.$router.push('/worker/adopt/' + key)
                })
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            tableData() {
                const data = []

                for (let i = 0; i < this.workers.length; i++) {
                    data.push({
                        adoption_key: this.workers[i].adoption_key,
                        docker_version: this.workers[i].docker_version,
                        cpu: this.workers[i].cpu,
                        ram: (this.workers[i].ram / 1000000000).toFixed(2) + 'GB',
                        swap: (this.workers[i].swap / 1000000000).toFixed(2) + 'GB',
                        ip: this.workers[i].ip,
                        port: this.workers[i].port,
                        gpu: this.workers[i].gpu,
                        license_disabled: this.workers[i].license_disabled
                    })
                }

                return data
            }
        },
        watch: {
            adoptWorkerPrompt() {
                if (!this.adoptWorkerPrompt) this.selected = {}
            }
        },
        beforeDestroy() {
            clearInterval(this.updateDataTimer)
        },
        mounted() {
            this.isMounted = true
            this.loadData()
            this.updateDataTimer = setInterval(() => { this.loadData() }, 3000)
        }

    }
</script>
